import { getEnv } from './env';

export function getAuthEventCookieName(
  event: 'logged-in' | 'logged-out',
  retailUnit: string,
  environment: ReturnType<typeof getEnv> = getEnv(),
): string {
  const baseName = `auth0-${event}`;

  if (environment === 'development' && import.meta.env.VITE_LOCAL_AUTH === 'true') {
    return `${baseName}-development-${retailUnit}`;
  }

  return baseName;
}

export function getAuthTokenCookieName(retailUnit: string, environment: ReturnType<typeof getEnv> = getEnv()): string {
  return environment === 'development' && import.meta.env.VITE_LOCAL_AUTH === 'true'
    ? `auth0-session-development-${retailUnit}`
    : `auth0-session-${retailUnit}`;
}
